import { axios } from '@Root/API'

export const getHesa = () => {
	return axios.get('contacts/get-help-text/student-hesa')
}
